import React, { useState, useRef, useEffect } from "react";
import S from "./ContactComponent.styled";

type Props = {
  backgroundColor: string;
};
declare const window: {
  hbspt: {
    forms: {
      create: any;
    };
  };
};

const ContactComponent = ({ backgroundColor }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [initiated, setInitiated] = useState(false);

  useEffect(() => {
    if (window.hbspt?.forms?.create) {
      if (ref.current && !initiated) {
        setInitiated(true);
        window.hbspt.forms.create({
          target: "#hubspot-form",
          region: "na1",
          portalId: "6464302",
          formId: "05f19539-b3a0-4492-b1da-5edf94eadf0e",
          cssClass: "hubspot-form",
        });
      }
    }
  }, [ref, initiated]);

  return (
    <S.Form backgroundColor={backgroundColor} id="hubspot-form" ref={ref} />
  );
};

export default ContactComponent;
